var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatahubLogoColorLoadingPendulum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 86 87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1CA8DD;}\n\t.st1{fill:#1CA8DD;}\n\t.st2{fill:#4C4E54;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,1.2c-7.7-2.6-15,4.7-12.5,12.4L19.6,26c0.7,2,0.6,4.2,0,6.2l-4.2,12.4c-2.6,7.7,4.7,15,12.4,12.5 l12.5-4.2c2-0.7,4.1-0.7,6.1,0L58.9,57c7.7,2.5,14.9-4.8,12.3-12.5l-4.1-12.2c-0.7-2-0.7-4.2,0-6.3l4.1-12.4 c2.6-7.7-4.8-15-12.4-12.5L46.5,5.3c-2,0.7-4.2,0.7-6.3,0L28.1,1.2z M43.3,44c3.9,0,7.7-1.6,10.5-4.4c2.8-2.8,4.4-6.6,4.4-10.5 c0-3.9-1.6-7.7-4.4-10.5c-2.8-2.8-6.6-4.4-10.5-4.4c-3.9,0-7.7,1.6-10.5,4.4c-2.8,2.8-4.4,6.6-4.4,10.5c0,3.9,1.6,7.7,4.4,10.5 C35.6,42.4,39.4,44,43.3,44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.9,33.5c0.6,0.6,1.3,1,2,1.4c0.8,0.3,1.6,0.5,2.4,0.5s1.6-0.2,2.4-0.5c0.8-0.3,1.4-0.8,2-1.4 c0.6-0.6,1-1.3,1.3-2c0.3-0.8,0.5-1.6,0.5-2.4c0-0.8-0.2-1.6-0.5-2.4c-0.3-0.8-0.8-1.4-1.3-2c-1.2-1.2-2.7-1.8-4.4-1.8 c-1.7,0-3.2,0.7-4.4,1.8c-1.2,1.2-1.8,2.8-1.8,4.4C37.1,30.8,37.8,32.3,38.9,33.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatahubLogoColorLoadingPendulum);
export default __webpack_public_path__ + "static/media/datahub-logo-color-loading_pendulum.8ceee63f.svg";
export { ForwardRef as ReactComponent };